module.exports = __webpack_public_path__ + "img/onlineresume.f18973cc.svg";